import { AppBar as RaAppBar } from "react-admin";
import UserMenu from "./UserMenu";

function AppBar(props) {
  return <RaAppBar {...props} userMenu={<UserMenu />} />;
}
export default AppBar;
